/**
 * In this file we are importing different fontawesome icons
 * to use in .tsx files without need to import each
 * icon manually in each file.
 * Each icon imports globally for the whole project.
 *
 * After importing here, you can write, for example:
 *
 * // SomeFile.tsx
 * <FontAwesomeIcon icon="some-icon" />
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSignOutAlt,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faFilter,
  faAddressCard,
  faTimes,
  faColumns,
  faFileExcel,
  faSort,
  faSortUp,
  faSortDown,
  faGripLines,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faSearch,
  faSignOutAlt,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faAngleDoubleLeft,
  faFilter,
  faAddressCard,
  faTimes,
  faColumns,
  faFileExcel,
  faSort,
  faSortUp,
  faSortDown,
  faGripLines
);
